// URL path segments for the top-level tabs / list pages.
export const POST_TYPES_PATH = '/post-types';
export const TAXONOMIES_PATH = '/taxonomies';

// Core-data postType names that store the user-defined records.
export const POST_TYPE_ENTITY = 'wp_user_post_type';
export const TAXONOMY_ENTITY = 'wp_user_taxonomy';

// Sentinel for the edit-route param when creating a new record.
export const NEW_ID = 'new';
